import React, { useMemo } from 'react'
import { getFeathersClient } from './feathers-client'
import { ColorSet } from '@/theme/color'
import { User } from '../../../../shared-src/user'
import { AddReactionButton } from './add-reaction-button'

interface MessageReactionsProps {
	messageUlid: string
	channelId: string
	reactions?: string
	selfUser: User | null
	selfUserColorSet: ColorSet
	senderColorSet: ColorSet
	isMyMessage: boolean
}

type ParsedReactions = Record<string, string[]>

export function MessageReactions(props: MessageReactionsProps) {
	const messagesService = getFeathersClient().service('messages')

	const parsedReactions = useMemo<ParsedReactions>(() => {
		if (!props.reactions)
			return {}
		try {
			return JSON.parse(props.reactions)
		} catch (error) {
			console.error('Error parsing reactions:', error)
			return {}
		}
	}, [props.reactions])

	const reactionEntries = Object.entries(parsedReactions)

	const handleReactionClick = async (emoji: string) => {
		if (!props.selfUser?.userId)
			return

		const userHasReacted = parsedReactions[emoji]?.includes(props.selfUser?.userId)
		const action = userHasReacted ? 'remove-reaction' : 'add-reaction'

		try {
			await messagesService.patch(props.messageUlid, {
				action,
				emoji,
				channelId: props.channelId
			})
		} catch (error) {
			console.error('Error updating reaction:', error)
		}
	}

	return (
		<div className={`flex flex-wrap gap-1 -mt-1.5 mx-2 ${props.isMyMessage ? 'justify-end' : 'justify-start'}`}>
			{reactionEntries.map(([emoji, userIds]) => {
				const count = userIds.length
				const userHasReacted = props.selfUser?.userId && userIds.includes(props.selfUser?.userId)

				return (
					<button
						key={emoji}
						onClick={() => handleReactionClick(emoji)}
						className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-sm shadow-md hover:shadow transition-shadow"
						style={{
							backgroundColor: userHasReacted ? props.selfUserColorSet.background : 'white',
							// border: `1px solid ${props.senderColorSet.border}`
							// border: `1px solid lightgray`
						}}
						title={userHasReacted ? 'Remove reaction' : 'Add reaction'}
					>
						<span>{emoji}</span>
						<span className="text-xs">{count}</span>
					</button>
				)
			})}

			{/* <div className="shadow-md rounded-full">
				<AddReactionButton
					messageUlid={props.messageUlid}
					channelId={props.channelId}
					selfUser={props.selfUser}
					selfUserColorSet={props.selfUserColorSet}
				/>
			</div> */}
		</div>
	)
}